export default {
	namespaced: true,
	state: {
		shopList: [],
		isVisible: false,
		locationVisible: false,
		searchText: '',
		searchType: 1,
		isSearching: false,
		chooseShop: {},
		locationChoose: [],
		locationList: [],
		currentLocation: []
	},
	mutations: {
		upDateState(state, data) {
			state[data.key] = data.value
		}
	},
	actions: {
		update({ commit, state }, data) {
			commit('upDateState', data)
		}
	}
}
